// Kunden-Version: Anfragetext für Umzugsfirmen ("An Umzugsfirmen senden").

import type { Draft } from "./zustand.ts";

export function requestText(d: Pick<Draft, "survey" | "privat">): { subject: string; body: string } {
  const r = d.privat?.result;
  const from = r?.fromCity ?? "?";
  const to = r?.toCity ?? "?";
  const lines = [
    "Guten Tag,",
    "",
    `ich plane einen Umzug von ${from} nach ${to}, Wunschtermin: ${r?.dateText ?? "noch offen"}.`,
    ...(r?.volumeText ? [`Das Umzugsvolumen liegt laut Aufnahme bei ca. ${r.volumeText} m³.`] : []),
    `Im Anhang finden Sie meine Umzugsaufnahme mit allen Räumen, Möbeln, der ungefähren Kartonzahl und Fotos (erstellt mit Umzugsscan, Aufnahme-Code ${d.privat?.code ?? "–"}). Eine Besichtigung ist dafür nicht nötig.`,
    "",
    "Ich freue mich über Ihr Angebot.",
    "",
    "Mit freundlichen Grüßen",
    d.survey.contactName ?? "",
    d.survey.phone ?? "",
  ];
  return { subject: `Anfrage Umzug ${from} nach ${to}`, body: lines.join("\n").trim() };
}
